import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import { EncryptYamatoBaggageRequest, DefaultService as api } from 'src/sdk-servicing';
import { ServicingBaseClass } from '@common/components';
import {
  EncryptYamatoBaggageResultState,
  EncryptYamatoBaggageResultStore,
  resetEncryptYamatoBaggageResult,
  selectEncryptYamatoBaggageResultState,
  setEncryptYamatoBaggageResultFromApi,
} from '@common/store/encrypt-yamato-baggage-result';

@Injectable()
export class EncryptYamatoBaggageResultStoreService extends ServicingBaseClass {
  /** ヤマト手荷物連携パラメータ暗号化APIのレスポンス */
  private _result$ = this._store.pipe(
    select(selectEncryptYamatoBaggageResultState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  /**
   * エラーが発生していないヤマト手荷物連携パラメータ暗号化APIのレスポンス通知
   */
  get success$(): Observable<EncryptYamatoBaggageResultState> {
    return this._result$.pipe(filter((state) => state.isFailure === false));
  }

  /**
   * エラーが発生しているヤマト手荷物連携パラメータ暗号化APIのレスポンス通知
   */
  get failure$(): Observable<EncryptYamatoBaggageResultState> {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  constructor(private _store: Store<EncryptYamatoBaggageResultStore>, private api: api) {
    super();
  }

  override destroy(): void {
    this.clear();
  }

  /**
   * ヤマト手荷物連携パラメータ暗号化APIを呼び出す
   * @param parameter ヤマト手荷物連携パラメータ暗号化PIのリクエストパラメータ
   */
  request(parameter: EncryptYamatoBaggageRequest): void {
    const call = this.api.ordersEncryptYamatoBaggagePost(parameter);
    this._store.dispatch(setEncryptYamatoBaggageResultFromApi({ call }));
  }

  /**
   * ヤマト手荷物連携パラメータ暗号化取得結果ストアをクリアする
   */
  clear(): void {
    this._store.dispatch(resetEncryptYamatoBaggageResult());
  }
}
